/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-useless-constructor */
import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import Dropdown from 'Common/Components/Dropdown';
import { cvssOptions } from 'Screens/Constants';
import { DropdownStyle, Wrapper } from './styled';

const Item = (props) => (
  <div className="d-inline-flex item-option">
    <span>{props.title}</span>
  </div>
);

Item.propTypes = {
  title: PropTypes.string.isRequired
};

class Select extends React.Component {
  constructor (props) {
    super(props);

    this.onChange = this.onChange.bind(this);
  }

  onChange (value) {
    this.props.updateValue(value);
  }

  render () {
    const { defaultValue } = this.props;
    const options = cvssOptions.map((element) => ({ label: <Item title={ element.desc } />, value: element.name }));

    return (
      <Wrapper>
        <Dropdown respectCapitalLetters customStyle={ DropdownStyle(this.props.theme) } options={ options } className="ease-of-resolution" updateValue={ this.onChange } placeholder="Select" defaultValue={ defaultValue } />
      </Wrapper>
    );
  }
}

Select.propTypes = {
  defaultValue: PropTypes.string,
  updateValue: PropTypes.func.isRequired,
  theme: PropTypes.string.isRequired
};

Select.defaultProps = {
  defaultValue: null,
  theme: null
};

export default withRouter(Select);
